export default class Stock {
    constructor(options = {}) {
        const defaultOptions = {
            stockBtn: '.js-popup-stock',
            popupTitle: '.js-stock-title',
            popupDescr: '.js-stock-descr',
            popupImg: '.js-stock-img',
            formHideInp: '.js-stock-value'
        }

        this.options = {...defaultOptions, ...options};

        this.stockBtns = document.querySelectorAll(this.options.stockBtn);
        this.popupTitle = document.querySelector(this.options.popupTitle);
        this.popupDescr = document.querySelector(this.options.popupDescr);
        this.popupImg = document.querySelector(this.options.popupImg);
        this.formHideInp = document.querySelector(this.options.formHideInp);

        this.init();
    }

    init() {
        if (!this.stockBtns) return;

        this.stockBtns.forEach(btn => {
            btn.addEventListener('click', () => {
                let title = btn.dataset.title;
                let descr = btn.dataset.descr;
                let img = btn.dataset.img;

                this.formHideInp.value = title;
                this.popupTitle.textContent = title;
                this.popupDescr.textContent = descr;
                this.popupImg.style.backgroundImage = `url('${img}')`;
            });
        })
    }
}